import { createAsyncThunk } from "@reduxjs/toolkit";
import { getBranchTransReportApi } from "../../../apiservice/reports";

export const fetchBranchTransactionOutward = createAsyncThunk(
  "branchTransactionOutward/fetch",
  async ({ filters }, { rejectWithValue }) => {
    try {
      const payload = {
        status: filters?.status || "p",
      };
      const res = await getBranchTransReportApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
